<template>
  <a
    class="breadcrumb__back button button--text button--small padding-left-right-0"
    :href="link | mgnlLink('url')"
  >
    <i class="icon-arrow-sx" aria-hidden="true" v-if="icon"></i>
    <span>{{buildLabel}}</span>
  </a>
</template>

<script>
export default {
  name: "pg-breadcrumb",

  props: {
    link: {
      type: Object,
      default: () => {}
    },
    label: {
      type: String,
      default: ""
    },
    icon: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    buildLabel() {
      return this.$msg("common.breadcrumb.back.text") + " " + this.label;
    }
  },
  methods: {}
};
</script>

<style scoped>
#root > a {
  margin: 50px;
}
</style>